<div>
  <div
    class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2 px-3">
    <div class="d-flex justify-content-between align-items-center gap-3">
      <h2 class="mb-0">Commission Adjustment</h2>
    </div>

    <div class="d-flex align-items-center gap-3">
      <p-button label=" Clear Filters" (click)="clearTable(dt)" />
      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />
      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>
  <div class="col-12">
    <p-table
      #dt
      stripedRows
      scrollHeight="calc(100vh - 265px)"
      responsiveLayout="scroll"
      [value]="gpAdjustmentLists"
      [rowHover]="true"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 1000]"
      [showCurrentPageReport]="true"
      [resizableColumns]="true"
      paginatorStyleClass="paginator-table-inside "
      styleClass="table-listing p-datatable-customers p-head-pad">
      <ng-template pTemplate="caption">
        <div class="d-flex align-items-center">
          <ng-container *ngIf="gpAdjustmentLists?.length">
            <div class="form-group has-float-label me-2 px-2">
              <input
                jniAutoCompleteBlocker
                class="form-control filter me-2 text-end"
                type="text"
                [value]="total | number: '1.2-2'"
                disabled />
              <label class="form-label" for="total">Total</label>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr class="table-head">
          <th pSortableColumn="Date">
            Date <p-sortIcon field="Date"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="Date"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="ProjectName">
            Project name <p-sortIcon field="ProjectName"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="ProjectName"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CategoryID">
            Category ID <p-sortIcon field="CategoryID"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CategoryID"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="AmountinTransactionCurrency">
            Amount in transaction
            <p-sortIcon field="AmountinTransactionCurrency"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="AmountinTransactionCurrency"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CommissionAdjustmentID">
            Commission adjustment id
            <p-sortIcon field="CommissionAdjustmentID"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CommissionAdjustmentID"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="Description">
            Description <p-sortIcon field="Description"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="Description"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CreatedDateTime">
            Created date and time
            <p-sortIcon field="CreatedDateTime"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CreatedDateTime"
              display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="CreatedBy">
            Created by <p-sortIcon field="CreatedBy"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="CreatedBy"
              display="menu"></p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-gpAdjustmentList
        let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="gpAdjustmentList"
          [pSelectableRowIndex]="rowIndex">
          <td>{{ gpAdjustmentList.Date | date: "MM-dd-yyyy" }}</td>
          <td>{{ gpAdjustmentList.ProjectName }}</td>
          <td>{{ gpAdjustmentList.CategoryID }}</td>
          <td class="align-right">
            {{ gpAdjustmentList.AmountinTransactionCurrency | number: "1.2-2" }}
          </td>
          <td>{{ gpAdjustmentList.CommissionAdjustmentID }}</td>
          <td>{{ gpAdjustmentList.Description }}</td>
          <td>
            <span *ngIf="gpAdjustmentList?.CreatedDateTime | hidedynamicsdate">
              {{ gpAdjustmentList.CreatedDateTime | date: "MM-dd-yyyy" }}
            </span>
          </td>
          <td>{{ gpAdjustmentList.CreatedBy }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No GP Adjustment found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
